export default __webpack_public_path__ + "static/hero_business_back_img_3-98da49af98f6403d0a8b009f5f15f6c0.png";